var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"App"},[_c('Authenticator'),(this.$store.state.api.isAuthenticated)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }